// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-__Category-module___main","category_item":"src-components-__Category-module___category_item","description":"src-components-__Category-module___description","spinner":"src-components-__Category-module___spinner","detail_button":"src-components-__Category-module___detail_button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Category.module.css
// module id = 299
// module chunks = 10